import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, Crown, Sparkles } from "lucide-react";

interface PremiumLockedContentProps {
  title: string;
  description: string;
  features?: string[];
  onUpgrade: () => void;
}

export function PremiumLockedContent({ 
  title, 
  description, 
  features = [],
  onUpgrade 
}: PremiumLockedContentProps) {
  return (
    <Card className="border-2 border-dashed border-muted-foreground/20 bg-gradient-to-br from-muted/30 to-muted/10">
      <CardHeader className="text-center pb-2">
        <div className="mx-auto mb-4 h-20 w-20 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
          <Lock className="h-10 w-10 text-primary/60" />
        </div>
        <CardTitle className="text-xl flex items-center justify-center gap-2">
          <Crown className="h-5 w-5 text-amber-500" />
          {title}
        </CardTitle>
        <CardDescription className="text-base">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="text-center space-y-6">
        {features.length > 0 && (
          <ul className="space-y-2 text-sm text-muted-foreground max-w-md mx-auto">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center gap-2 justify-center">
                <Sparkles className="h-4 w-4 text-amber-500" />
                {feature}
              </li>
            ))}
          </ul>
        )}
        
        <div className="space-y-3">
          <Button 
            size="lg" 
            onClick={onUpgrade}
            className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-8"
          >
            <Crown className="h-5 w-5 mr-2" />
            Desbloquear com Premium
          </Button>
          <p className="text-xs text-muted-foreground">
            Acesso ilimitado a todos os recursos
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
